enum DeviceId {
  TV = 1,
  Mobile = 2,
  Tablet = 3,
  Desktop = 4,
  GamesConsole = 5,
}

export default DeviceId;
